import imagesLoaded from 'imagesloaded';

export class SsLazy {
  constructor ( elm ) {
    this.elm = elm;
  }

  load ( src ) {
    const imgEl = new Image();
    imgEl.setAttribute( 'src', src );
    const img = imagesLoaded( imgEl );
    return new Promise( ( resolve, reject ) => {
      img.on( 'done', () => { resolve(); } );
      img.on( 'fail', () => { reject(); } );
    });
  }

  bkg () {
    const img = imagesLoaded( this.elm, { background: true } );
    return new Promise( ( resolve, reject ) => {
      img.on( 'done', () => { resolve(); } );
      img.on( 'fail', () => { reject(); } );
    });
  }

  lazy () {
    this.setSrc();
    const img = imagesLoaded( this.elm );
    return new Promise( ( resolve, reject ) => {
      img.on( 'done', () => { resolve(); } );
      img.on( 'fail', () => { reject(); } );
    });
  }

  setSrc () {
    this.elm.setAttribute(
      'src',
      this.getData( 'src' )
    );
  }

  getData ( data ) {
    return this.elm.getAttribute( 'data-' + data );
  }
}
